import React from 'react'

const UserSettingsPage = () => {
  return (
    <div className="outlet-container">
      User settings page
    </div>
  )
}

export default UserSettingsPage
